import PropTypes from "prop-types";
import React from "react";
import {format} from "date-fns";

export default function DateField(props) {
    if(props.field && props.field.length > 0){
        let formatDate = props.field;
        if(!props.includeTime){
            formatDate = format(props.field, "MM/DD/YYYY");  
        }
        else {
            formatDate = format(props.field, "MM/DD/YYYY h:mm:ss aa");                  
        }

        let additionalStyles = props.styleClass ? props.styleClass : "";                                                  
        return (
            <span className={`fieldText ${additionalStyles}`}>
                {formatDate}
            </span>
        );
    }
    else {
        return (
            <span className={`fieldText placeholder`}>
                {props.placeholder}
            </span>
        );            
    }
}

DateField.propTypes = {
    field: PropTypes.string,
    placeholder: PropTypes.string,
    styleClass: PropTypes.string,
    includeTime: PropTypes.bool
};

